import React, {useEffect, useState, useCallback, useContext} from 'react';
import {UserContext} from '../../../context/UserContext';
import { useDropzone } from 'react-dropzone';
import { VscCloudUpload } from "react-icons/vsc";
import { SlTrash } from "react-icons/sl";
import {PaperClipIcon} from "@heroicons/react/20/solid";
import { GoDownload, GoEye  } from "react-icons/go";
import { LuSearchCheck } from "react-icons/lu";
import { S3UploadHandler, S3ListFiles, S3DeleteFile, S3GetFileUrl } from '../../../helper/s3ClientHandler';
import { getFormatedFileSize } from '../../../helper/fileSizeFormatter';

const S3UploaderWithDropzone = (name, path, orderEdit, fileType = "GML", orderStage, isOrder = false,  orderId=false , orderCreator=false, reviewVersion) => {
    const { user } = useContext(UserContext);
    const [uploading, setUploading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);

    const { getRootProps, getInputProps } = useDropzone({ onDrop: (acceptedFiles) => onDrop(acceptedFiles, path),});

    const onDrop = async (acceptedFiles, path) => {
        if (acceptedFiles.length === 0) return;
        setUploading(true);

        try {
            const fileIds = await S3UploadHandler(acceptedFiles, path);
            return fileIds;
        } catch (error) {
            console.error('Error uploading file: ', error);
            alert('Error uploading file. Please try again.');
            return [];
        } finally {
            setUploading(false);
            setUploadProgress(0);
            fetchUploadedFiles();
        }
    };

    const fetchUploadedFiles = useCallback(async () => {
        try {
            const files = await S3ListFiles(path);
            setUploadedFiles(files || []);
        } catch (err) {
            console.error('Error fetching uploaded files:', err);
        }
    }, [path]);


    const handleDeleteFile = async (keyToDelete) => {
        try {
            await S3DeleteFile(keyToDelete);
            await fetchUploadedFiles();
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };


    const generateDownloadUrl = async (s3Key) => {
        try {
            const url = await S3GetFileUrl(s3Key);
            const link = document.createElement('a');
            link.href = url;
            console.log('Download URL:', s3Key);
            link.download = s3Key.split("/").pop();
            link.click();
        } catch (error) {
            console.error('Error generating download URL:', error);
        }
    };

    const getContentAfterSecondLastSlash = (str) => {
        const parts = str?.split('/');
        // Get the content after the second last '/'
        const content = parts?.slice(-2).join('/');
        return content.substring(0, content.lastIndexOf('.'));
    }

    const getFileFromUrl = (url) => {
        const fileIdWithFileName = getContentAfterSecondLastSlash(url);
        const fileId = fileIdWithFileName?.split('/')[0];
        const filename = fileIdWithFileName?.split('/')[1];
        return {fileId, filename};
    }


    useEffect(() => {
        fetchUploadedFiles();
    }, [fetchUploadedFiles]);

    return (
        <div>
            <div className={" sm:gap-4"}>
                {(uploadedFiles.length > 0 || orderEdit === true) ? (
                    <div>
                        {(name !== null) ? (<b className={"block text-left font-semibold mr-2 text-gray-900  pb-4"}>{name}</b>) : ("")}
                        <div className="mt-1 mb-4 text-sm text-gray-900">
                            <ul className="divide-y divide-gray-100 rounded-md ">
                                {uploadedFiles.map((file, key) => {
                                    // check if filename ends with .geojson
                                    if (file.key.split(".").pop() === "geojson") {
                                        return null;
                                    }
                                    return (
                                    <li key={key} className="flex  items-center justify-between py-4 rounded-lg  text-sm leading-6">
                                        <div className="flex w-0 flex-1 justify-items-center items-center">
                                            <PaperClipIcon aria-hidden="true"  className="h-4 w-4 flex-shrink-0 text-gray-600/60 "/>
                                            <div className="ml-4 flex min-w-0 flex-1 gap-2">
                                                <button onClick={() => generateDownloadUrl(file.key)} className="cursor-pointer text-sm truncate font-medium   text-gray-600/60  flex gap-x-2">
                                                    <span className="truncate block   font-medium">{file.key.split("/").pop()}</span>
                                                </button>
                                                <span className="flex-shrink-0 ml-2 mt-0.5 text-xs text-gray-600/60">({getFormatedFileSize(file.size)})</span>
                                            </div>
                                        </div>
                                        <div className="ml-4 flex-shrink-0">
                                            {(file.key.split(".").pop() === "gml") ?
                                                (isOrder === true  && orderId !== false && reviewVersion !== "documents"&& reviewVersion !== false ) ? (

                                                    <button target={"_blank"} onClick={() => window.open(`/viewer?fId=${getFileFromUrl(file?.key).fileId}&f=${getFileFromUrl(file?.key).filename}&cId=${orderCreator}&vId=${reviewVersion}&rId=1&oId=${orderId}`)}  className="inline-flex my-2 border  border-gray-500  items-center rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900  hover:bg-gray-50">
                                                        <LuSearchCheck   className={"h-4 w-4 mr-2"}/> Plan prüfen
                                                        {/* && orderStage === "inReview" */}
                                                    </button>
                                                ) : (
                                                    <button target={"_blank"} onClick={ () => window.open(`/viewer?fId=${getFileFromUrl(file?.key).fileId}&f=${getFileFromUrl(file?.key).filename}&cId=${orderCreator}&vId=${reviewVersion}&rId=0&oId=${orderId}`)}   className="inline-flex my-2 border  border-gray-500  items-center rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900  hover:bg-gray-50">
                                                        <GoEye  className={"h-4 w-4 mr-2"}/> Plan anzeigen
                                                    </button>
                                                )
                                                : ("")
                                            }
                                            <button onClick={() => generateDownloadUrl(file.key)}  className="inline-flex ml-2 border  border-gray-500  items-center rounded-md bg-white px-3 py-2 text-xs font-semibold text-gray-900  hover:bg-gray-50">
                                                <GoDownload   className={"h-4 w-4 mr-2"}/> Download
                                            </button>
                                        </div>

                                        {(orderEdit === true) && (
                                            <button onClick={() => handleDeleteFile(file.key)}
                                                    className="cursor-pointer ml-4 flex gap-x-2">
                                                <SlTrash className="h-4 w-4 text-red flex-none text-gray-900"  aria-hidden="true"/>
                                            </button>
                                        )}
                                    </li>
                                )})}
                            </ul>
                        </div>
                    </div>
                ): (
                    <div className={"py-5"}>
                        Keine Dokumente vorhanden
                    </div>
                )}

            </div>

            {(orderEdit === true) && (
                <div {...getRootProps()}
                     className={ "mt-2 bg-white flex justify-center rounded-lg border-2 border-dashed border-gray-500 px-6 py-4"}>
                    <div className="text-center self-center">

                        <VscCloudUpload className="mx-auto h-12 w-12 text-gray-500" aria-hidden="true"/>
                        <div className="mt-4 flex text-left  text-sm leading-6 text-gray-900">
                            <label
                                htmlFor="file-upload"
                                className="relative text-sm text-center cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                            >

                                {(uploading) ? (<p>Fortschritt: {uploadProgress}%</p>) : (<><span className={"block"}>Datei per Klick</span><span
                                    className="pl-1 font-normal"> oder per drag & drop hochladen</span><p
                                    className="text-xs leading-5 text-gray-600">{fileType} bis zu 10MB</p></>)}
                                <input {...getInputProps()} id="file-upload" name="file-upload" type="file"
                                       className="sr-only"/>
                            </label>

                        </div>
                    </div>
                </div>
            )}



        </div>

    );
};

export default S3UploaderWithDropzone;
